import update from 'immutability-helper';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'app/common/i18n';

import {entitiesCount, recentEntities} from 'app/client/api';
import {showAppBusy, handleAppError} from './app';
import {receiveAcademiesCount} from './academy';
import {receiveCandidatesCount} from './candidates';

const initialState = {
	recentEntities: [],
	assessmentsPurchaseList: [],
	timePeriod: {
    options: [
      {value: I18n.t('dashboard.time_periods.last_week'), label: I18n.t('dashboard.time_periods.last_week')}, // 1 week in seconds
      {value: I18n.t('dashboard.time_periods.last_month'), label: I18n.t('dashboard.time_periods.last_month')} // 1 month in seconds
  	],
    selected: I18n.t('dashboard.time_periods.last_week')
  },
  entitiesCount: {
    totalCount: 0,
    timePeriodBasedCount: 0
  },
};

const RECEIVE_ASSESSMENTS_PURCHASE_LIST = 'entity/RECEIVE_ASSESSMENTS_PURCHASE_LIST';
const SET_TIME_PERIOD = 'entity/SET_TIME_PERIOD';
const RECEIVE_RECENT_ENTITIES = 'entity/RECEIVE_RECENT_ENTITIES';
const RECEIVE_TOTAL_ENTITIES_COUNT = 'entity/RECEIVE_TOTAL_ENTITIES_COUNT';
const RECEIVE_TIME_PERIOD_BASED_ENTITIES_COUNT = 'entity/RECEIVE_TIME_PERIOD_BASED_ENTITIES_COUNT';

export function receiveEntitiesCount(count, timePeriod) {
  if(timePeriod) {
    return {type: RECEIVE_TIME_PERIOD_BASED_ENTITIES_COUNT, payload: count}
  }
  return {type: RECEIVE_TOTAL_ENTITIES_COUNT, payload: count}
}

export function setTimePeriod(payload) {
  return {type: SET_TIME_PERIOD, payload}
}

function receiveRecentEntities(payload) {
  return {type: RECEIVE_RECENT_ENTITIES, payload}
}

function receiveAssessmentsPurchaseList(payload) {
  return { type: RECEIVE_ASSESSMENTS_PURCHASE_LIST, payload }
}

export function fetchRecentEntities() {
  return async dispatch => {
    dispatch(showAppBusy(true));
    try {
      let response = await recentEntities();
      let entities = _.reduce(response.data, (result, value) => result = result.concat(value), [] );
      dispatch(receiveRecentEntities(entities));
      dispatch(showAppBusy(false));
    } catch(exception) {
      dispatch(showAppBusy(false));
      dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}

export function fetchEntitiesCount(selectedTimePeriod) {
  let timePeriod = null;
  if (selectedTimePeriod === I18n.t('dashboard.time_periods.last_week'))
    timePeriod = moment().add(-7, 'days').unix();
  else if (selectedTimePeriod === I18n.t('dashboard.time_periods.last_month'))
    timePeriod = moment().add(-30, 'days').unix();
  return async dispatch => {
    dispatch(showAppBusy(true));
    let params = timePeriod ? { since: timePeriod} : null;
    try {
      let response = await entitiesCount(params);
      let _entitiesCount = response.data.academies + response.data.companies 
        + response.data.atsProviders;
      dispatch(receiveEntitiesCount(_entitiesCount, timePeriod));
      dispatch(receiveAcademiesCount(response.data.academies, timePeriod));
      dispatch(receiveCandidatesCount(response.data.candidates, timePeriod));
      // dispatch(receiveCompaniesCount(response.data.companies));
      dispatch(showAppBusy(false));
    } catch(exception) {
      dispatch(showAppBusy(false));
      dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}

export function fetchAssessmentsPurchaseList() {
  return dispatch => {
    let assessmentsPurchased = {
      type:"integer",
      minimum:50,
      maximum:1000,
      multipleOf:50
    }

    let assessmentsPurchaseList = [];

    for(let i = assessmentsPurchased.minimum; i<=assessmentsPurchased.maximum; i = i + assessmentsPurchased.multipleOf) {
      assessmentsPurchaseList.push({value: i});
    }

    dispatch(receiveAssessmentsPurchaseList(assessmentsPurchaseList));
  }
}

export default function(state = initialState, action) {

	let {type, payload} = action;

	switch(type) {

		case RECEIVE_ASSESSMENTS_PURCHASE_LIST:
      return update(state, { assessmentsPurchaseList: {$set: payload}});

    case SET_TIME_PERIOD:
      return update(state, {timePeriod: {selected: {$set: payload}}});

    case RECEIVE_RECENT_ENTITIES:
      return update(state, {recentEntities: {$set: payload}});

    case RECEIVE_TOTAL_ENTITIES_COUNT:
      return update(state, {entitiesCount: {totalCount: {$set: payload} } });

    case RECEIVE_TIME_PERIOD_BASED_ENTITIES_COUNT:
      return update(state, {entitiesCount: {timePeriodBasedCount: {$set: payload} } });

    default:
      return state;

	}
}


// WEBPACK FOOTER //
// ./src/reducers/entity.js